export class Podcast {

	constructor(elem) {
		this.elem = elem;

		this.podcastUrl = this.elem.dataset.podcastUrl;
		this.podcastHeight = this.elem.dataset.podcastHeight;

		this.addEventHandlers();
	}

	/**
	 * The event handler
	 */
	addEventHandlers() {
		this.elem.addEventListener('click', (e) => {
			this.handleClick(e);
		})
	}

	/**
	 * Click event
	 * @param e
	 */
	handleClick(e) {
		e.preventDefault();
		window.open(this.podcastUrl, 'popUpWindow', `height=${this.podcastHeight},width=500,left=1000,top=100,resizable=no,scrollbars=no,toolbar=no,menubar=no,location=no,directories=no, status=yes`);
	}

	/**
	 * I use the classname to target the element, because I can't add data-attributes to the CKEditor plugin
	 * @returns {string}
	 */
	static getSelector() {
		return '[data-podcast]';
	}
}
